import createIcon from '../../createIcon';

/**
 * @component @name GroupAdd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOVY3SDIwVjlIMThWMTFIMjBWMTNIMjJWMTFIMjRWOUgyMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04IDEyQzEwLjIxIDEyIDEyIDEwLjIxIDEyIDhDMTIgNS43OSAxMC4yMSA0IDggNEM1Ljc5IDQgNCA1Ljc5IDQgOEM0IDEwLjIxIDUuNzkgMTIgOCAxMloiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik04IDEzQzUuMzMgMTMgMCAxNC4zNCAwIDE3VjIwSDE2VjE3QzE2IDE0LjM0IDEwLjY3IDEzIDggMTNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIuNTEgNC4wNUMxMy40MyA1LjExIDE0IDYuNDkgMTQgOEMxNCA5LjUxIDEzLjQzIDEwLjg5IDEyLjUxIDExLjk1QzE0LjQ3IDExLjcgMTYgMTAuMDQgMTYgOEMxNiA1Ljk2IDE0LjQ3IDQuMyAxMi41MSA0LjA1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjUzIDEzLjgzQzE3LjQyIDE0LjY2IDE4IDE1LjcgMTggMTdWMjBIMjBWMTdDMjAgMTUuNTUgMTguNDEgMTQuNDkgMTYuNTMgMTMuODNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GroupAdd = createIcon('GroupAdd', [
  ['path', { d: 'M22 9V7H20V9H18V11H20V13H22V11H24V9H22Z', key: 'z3csi8' }],
  [
    'path',
    {
      d: 'M8 12C10.21 12 12 10.21 12 8C12 5.79 10.21 4 8 4C5.79 4 4 5.79 4 8C4 10.21 5.79 12 8 12Z',
      key: '1wci9x',
    },
  ],
  ['path', { d: 'M8 13C5.33 13 0 14.34 0 17V20H16V17C16 14.34 10.67 13 8 13Z', key: '1g9u5g' }],
  [
    'path',
    {
      d: 'M12.51 4.05C13.43 5.11 14 6.49 14 8C14 9.51 13.43 10.89 12.51 11.95C14.47 11.7 16 10.04 16 8C16 5.96 14.47 4.3 12.51 4.05Z',
      key: 'mkedi',
    },
  ],
  [
    'path',
    {
      d: 'M16.53 13.83C17.42 14.66 18 15.7 18 17V20H20V17C20 15.55 18.41 14.49 16.53 13.83Z',
      key: '10n3e9',
    },
  ],
]);

export default GroupAdd;
